import useGetProductsByProperty from './useGetProductsByProperty';

const useGetProductsBySpaceId = (productId: string) => {
    const { data: products } = useGetProductsByProperty(productId);
    const filteredProducts = products?.filter(product => product.parent_id === productId);
    return filteredProducts || [];
};

export default useGetProductsBySpaceId;
